import { Formik } from 'formik'
import React from 'react'
import { UseMutateDistributionSubcategoryByIdReturn, staffingAgencyDetailsByIdDocument, useMutateDistributionSubcategoryById, useStaffingAgencyClearedFacilities, useStaffingAgencyDetailsById } from 'src/queries'
import Form from './Form'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { MutateDistributionSubcategoryByIdMutation } from 'src/gql/graphql'
import { emptyStringToNull } from 'src/helpers/formHelpers'
import { pick } from 'lodash'

export type Values = Parameters<UseMutateDistributionSubcategoryByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: string
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const agency = useStaffingAgencyDetailsById(id)
  const clearedFacilities = useStaffingAgencyClearedFacilities()
  if (agency === undefined) {
    throw new Error('Could not load staffing agency!')
  }
  const update = useMutateDistributionSubcategoryById()
  const initialState: Values = pick(agency, [
    'name',
    'staffingAgency.sdvosb',
    'staffingAgency.clearedFacility'
  ])
  const invalidateAgency = useInvalidateQueryByDocument(staffingAgencyDetailsByIdDocument)
  const handleSuccess = (data: MutateDistributionSubcategoryByIdMutation): void => {
    const id = data.cat?.distributionSubcategory?.updateById?.recordId
    if (typeof id === 'string') {
      void invalidateAgency({ id })
    }
    toggle()
  }
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const record = { ...data }
        emptyStringToNull(record, 'staffingAgency.sdvosb')
        emptyStringToNull(record, 'staffingAgency.clearedFacility')

        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <Form
          toggle={toggle}
          isLoading={update.isLoading}
          hasError={update.isError}
          clearedFacilities={clearedFacilities}
        />
      )}
    </Formik>
  )
}

export default FormContext
